<!-- // header \\ -->
<header class="header-section">
  <div class="comman-width menuFJC">
  <div class="mobileMenu">  
  <div class="mobileMenuLogo">
    <button class="slideToggle" (click)="humbergMenu()">
      <img id="slide-icon" src="assets/images/menu.png" />
    </button>

    <a routerLink="/Home" routerLinkActive="" class="logo"><img src="{{ logo }}" alt="hdrx-logo" /></a>
  </div>
    <nav class="navbar pull-right more margin-leftAuto">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a [routerLink]="['/Home']" (click)="slideToggle();" routerLinkActive="active">Home<span>&nbsp;</span></a>
        </li>
        <!-- <li class="nav-item">
          <a [routerLink]="['/aboutUs']" (click)="slideToggle()" routerLinkActive="active">About
            Us<span>&nbsp;</span></a>
        </li> -->
        <!-- <li class="nav-item">
          <a [routerLink]="['/pricing']" (click)="slideToggle()"
            routerLinkActive="active">Pricing<span>&nbsp;</span></a>
        </li> -->
        <li class="nav-item">
          <a [routerLink]="['/contact']" (click)="slideToggle()" routerLinkActive="active">Contact
            Us<span>&nbsp;</span></a>
        </li>
        <!-- <li class="nav-item download">
          <a [routerLink]="['/download-mobile-app']" (click)="slideToggle()" routerLinkActive="active">Download Mobile
            App<span>&nbsp;</span></a>
        </li> -->
        <li class="nav-item">
          <a
            routerLink="help"
            (click)="slideToggle()"
            routerLinkActive="active"
            >FAQ<span>&nbsp;</span></a
          >
        </li> 
      </ul>
    </nav>
   
    <!-- <div class="login" *ngIf="notLoggedin">
      <a href="javascript:;" class="signUp" (click)="openlogin_signup($event, 'sign_up')">Sign Up</a>
      <a href="javascript:;" (click)="openlogin_signup($event, 'sign_in')" class="last signIn">Sign In</a>
    </div> -->
    <!-- Logged In header -->
    <div class="header" Id="Search_Header" *ngIf="isLoggedin">
      <div class="headermenu">
        <div class="login_btn TestGroup" style="display: none;">
          <a href="javascript:;" (click)="openlogin_signup($event, 'groupnumber')"></a>
        </div>




        <div class="userArea">
          <i (click)="hidemenubar(); $event.stopPropagation()"></i>
        </div>
        <!-- Dropdown Menu -->
        <div class="menu_main" [hidden]="!menubar">
          <p>General</p>
          <ul>
            <li>
              <i><img src="../assets/images/email.svg" /></i>
              {{ sign_in_user_email }}
            </li>
            <li (click)="MySavedCards()">
              <i><img src="../assets/images/card.svg" alt="" /></i>
              My Cards
            </li>
          </ul>
          <p>Security</p>
          <ul>
            <li (click)="showchangepass($event)">
              <i><img src="../assets/images/change_pass.svg" alt="" /></i>
              Change Password
            </li>
            <li (click)="MakeSignOut()">
              <i><img src="../assets/images/logout.svg" alt="" /></i>
              Logout
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="login_btn TestGroup" style="display: none;">
      <a href="javascript:;" (click)="openlogin_signup($event, 'groupnumber')"></a>
    </div>
  </div>
  </div>
</header>
<!-- \\ header // -->



<div *ngFor="let message of messages" class="alert alert-success">
  {{ message.text }}
</div>
<div>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
  <!-- <app-homepage></app-homepage> -->
</div>

<!-- Tabs panel -->
<div class="signupbox" *ngIf="showloginbox">
  <div class="close_search_pharmacy_popup" (click)="removesignup($event)"></div>
  <div class="Signup_login">
    <div class="background_area">
      <h2>
        {{_AppName}}
      </h2>
      <p>
        Save up to 85% <br />on your <br />prescriptions <br />with {{_AppName}}!
      </p>
    </div>
    <div class="form_area">
      <nav>
        <a href="javascript:;" (click)="openlogin_signup($event, 'sign_in')" [class.active]="signin_fields">Sign In</a>
        <a href="javascript:;" (click)="openlogin_signup($event, 'sign_up')" [class.active]="signup_fields">Sign Up</a>
      </nav>
      <div class="signup_parent" *ngIf="signup_fields">
        <div class="form_sec">
          <div class="skip_btn" (click)="SkipSignUp()">Skip Sign up</div>
          <h2>Sign Up to {{_AppName}}</h2>
          <div class="field">
            <input type="email" name="email_signup" id="email_signup" placeholder=" " [(ngModel)]="sign_up_email" autocomplete="off"
              (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_CheckPattern($event)" />
            <label for="email_signup">Email Address</label>
          </div>
          <span>{{ sign_up_email_error }}</span>
          <div class="field">
            <input type="password" name="password_signup" id="password_signup" [(ngModel)]="sign_up_password"  autocomplete="off"
              placeholder=" " (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_CheckPattern($event)"
              (keypress)="StopWhiteSpace($event)" />
            <label for="password_signup">Password</label>
          </div>
          <span>{{ sign_up_password_error }}</span>
          <div class="field">
            <input type="password" name="c_password_signup" id="c_password_signup" [(ngModel)]="sign_up_cpassword"  autocomplete="off"
              placeholder=" " (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_CheckPattern($event)"
              (keypress)="StopWhiteSpace($event)" />
            <label for="c_password_signup">Confirm Password</label>
          </div>
          <span>{{ sign_up_cpassword_error }}</span>
        </div>
        <div class="signup_btn_sec">
          <div class="btns" (click)="MakeSignUp()">
            Sign Up
          </div>
          <div class="already">
            Already have an account ?
            <a href="javascript:;" (click)="openlogin_signup($event, 'sign_in')">Sign In here</a>
          </div>
        </div>
        <div class="Login_Signup_Error">{{ sign_up_error }}</div>
        <p class="tncbox">
          By tapping Sign Up below, you confirm that you accept the
          <a href="javascript:void(0)">Terms of Use</a>.
        </p>
      </div>

      <div class="signin_parent" *ngIf="signin_fields">
        <div class="form_sec">
          <h2>Sign In to {{_AppName}}</h2>
          <div class="field">
            <input type="email" name="email_signin" id="email_signin" placeholder=" " [(ngModel)]="sign_in_email"  autocomplete="off"
              (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_CheckPattern($event)" />
            <label for="email_signin">Email Address</label>
          </div>
          <span>{{ sign_in_email_error }}</span>
          <div class="field">
            <input type="password" name="password_signin" id="password_signin" placeholder=" "
              [(ngModel)]="sign_in_password" (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_CheckPattern($event)"  autocomplete="off"
              (keypress)="StopWhiteSpace($event)" />
            <label for="password_signin">Password</label>
          </div>
          <span>{{ sign_in_password_error }}</span>
        </div>
        <a href="javascript:;" class="forgot_btn" (click)="ForgotPassword()">Forgot Password</a>
        <div class="signup_btn_sec">
          <div class="btns" (click)="MakeSignIn()">
            Sign In
          </div>
          <div class="already">
            Don’t have account ?
            <a href="javascript:;" (click)="openlogin_signup($event, 'sign_up')">Sign up here</a>
          </div>
        </div>
        <div class="Login_Signup_Error">{{ sign_in_error }}</div>
      </div>
    </div>
  </div>
</div>
<!-- Change Password Box -->
<div class="change_password" *ngIf="changepassword">
  <div class="close_search_pharmacy_popup" (click)="removechangepass($event)"></div>
  <div class="changepassword_main">
    <h2>Change Password</h2>
    <div class="input_box">
      <div>
        <input type="password" id="currentpass" name="currentpass" placeholder=" " [(ngModel)]="current_password"  autocomplete="off"
          (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_ChangePassword($event)"
          (keypress)="StopWhiteSpace($event)" />
        <label for="currentpass">Current Password</label>
        <i (click)="changeIcon('1')" id="status1"></i>
      </div>
      <span>{{ current_password_error }}</span>
      <div>
        <input type="password" id="newpass" name="newpass" placeholder=" " [(ngModel)]="new_password"  autocomplete="off"
          (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_ChangePassword($event)"
          (keypress)="StopWhiteSpace($event)" />
        <label for="newpass">New Password</label>
        <i (click)="changeIcon('2')" id="status2"></i>
      </div>
      <span>{{ new_password_error }}</span>
      <div>
        <input type="password" id="confirmpass" name="confirmpass" placeholder=" " [(ngModel)]="c_new_password"  autocomplete="off"
          (keyup)="Keyup_ClearField($event)" (keypress)="StopWhiteSpace($event)" />
        <label for="confirmpass">Confirm New Password</label>
        <i (click)="changeIcon('3')" id="status3"></i>
      </div>
      <span>{{ c_new_password_error }}</span>
      <span style="color:red">{{ change_password_error }}</span>
      <div class="reset_button change_pwd_btn" (click)="UpdatePassWord()">
        Reset
      </div>
    </div>
  </div>
</div>

<!-- Forgot Password Box -->
<div class="change_password" *ngIf="forgotpassword_box">
  <div class="close_search_pharmacy_popup" (click)="removeforgot($event)"></div>
  <div class="changepassword_main forgot_pass">
    <h2>Forgot Password</h2>
    <div class="input_box">
      <div>
        <input type="email" id="forgotemail" name="forgotemail" placeholder=" " [(ngModel)]="forgot_email"  autocomplete="off"
          (click)="Keyup_ClearField($event)" (keyup)="Keyup_ClearField($event)"
          (blur)="OnBlur_ChangePassword($event)" />
        <label for="forgotemail">Email</label>
        <span style="color:red">{{ forgot_email_error }}</span>
      </div>
      <div>
        <div *ngIf="otp_sent">
          <input type="text" id="OTP" name="OTP" placeholder=" " [(ngModel)]="input_otp"  autocomplete="off"
            (click)="Keyup_ClearField($event)" (keyup)="Keyup_ClearField($event)"
            (blur)="OnBlur_ChangePassword($event)" />
          <label for="OTP">Enter OTP</label>
          <span style="color:red">{{ input_otp_error }}</span>
        </div>
      </div>

      <div class="reset_button" (click)="Submit_Email_OTP()">Submit</div>
    </div>
  </div>
</div>
<!-------Group Number Box------------>
<div class="change_password" *ngIf="Group_Number_Box">
  <!-- <div class="close_search_pharmacy_popup" (click)="removegroup($event)"></div> -->
  <div class="changepassword_main forgot_pass group_Number__box">
    <div class="skip_btn" (click)="SkipGroupNumber()">Skip Group Number</div>
    <h2>Group Number</h2>
    <div class="input_box">
      <div>
        <span class="staticgroup">HDRX</span><input type="number" id="InputGroup" name="InputGroup" placeholder=" "
          [(ngModel)]="InputGroupNumber" (click)="ClearErrorMessage_InputGroup()" (keyup)="Keyup_ClearField($event)"
          (keypress)="_GrnumberValidate($event)" />
        <label for="currentpass">Group Number</label>
      </div>
      <span>{{ input_groupnumber_error }}</span>
      <div class="reset_button" (click)="SubmitGroupNumber()">Submit</div>
    </div>
  </div>
</div>
<!------------------Reset Password---------------->
<div class="change_password" *ngIf="resetpassword_Box">
  <div class="close_search_pharmacy_popup" (click)="removechangepass($event)"></div>
  <div class="changepassword_main resetpass_box">
    <h2>Reset Password</h2>
    <div class="input_box">
      <div>
        <input type="password" id="resetnewpass" name="resetnewpass" placeholder=" " [(ngModel)]="reset_new_password"  autocomplete="off"
          (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_ChangePassword($event)"
          (keypress)="StopWhiteSpace($event)" />
        <label for="newpass">New Password</label>
        <i (click)="changeIcon('4')" id="status4"></i>
      </div>
      <span>{{ reset_new_password_error }}</span>
      <div>
        <input type="password" id="resetconfirmpass" name="resetconfirmpass" placeholder=" "  autocomplete="off"
          [(ngModel)]="reset_c_new_password" (keyup)="Keyup_ClearField($event)" (keypress)="StopWhiteSpace($event)" />
        <label for="resetconfirmpass">Confirm New Password</label>
        <i (click)="changeIcon('5')" id="status5"></i>
      </div>
      <span>{{ reset_c_new_password_error }}</span>
      <span style="color:red">{{ reset_update_password_error }}</span>
      <div class="reset_button" (click)="ResetPassword()">
        Reset
      </div>
    </div>
  </div>
</div>

<!--Search pharmacy popup-->
<div class="top_search">
  <div class="search_pharmacy_popup" *ngIf="ShowDrugdetails">
    <div class="close_search_pharmacy_popup" (click)="CloseDrugDetails()"></div>
    <div class="search_pharmacy_select">
      <h2>{{ SelectedDrug }}</h2>
      <div class="filter_box">
        <div class="lists_box" [ngClass]="{'singleDoseForm': DrugNameTypeSingle}">
          <div (click)="hideme[0] = !hideme[0]; $event.stopPropagation()">
            <label>Type</label>
            <div class="filtertext">
              {{ SelectedDrug }}
            </div>
            <i></i>
          </div>
          <div class="lists" [hidden]="!hideme[0]">
            <ul>
              <li *ngFor="let item of DrugTypeList" (click)="addActive_select($event, 0, item)"
                [ngClass]="{ active: item == Swap_Drug_With_MultiSource }">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
        <div class="lists_box" [ngClass]="{'singleDoseForm': DrugFormSingle}">
          <div (click)="hideme[1] = !hideme[1]; $event.stopPropagation()">
            <label>Form</label>
            <div class="filtertext">
              {{ DrugType }}
            </div>
            <i></i>
          </div>
          <div class="lists" [hidden]="!hideme[1]">
            <ul>
              <li *ngFor="let item of optionlist" (click)="addActive_select($event, 1, item.text)"
                [ngClass]="{ active: item.text == DrugType }">
                {{ item.text }}
              </li>
            </ul>
          </div>
        </div>
        <div class="lists_box" [ngClass]="{'singleDoseForm': DrugDoseSingle}">
          <div (click)="hideme[2] = !hideme[2]; $event.stopPropagation()">
            <label>Dosage</label>
            <div class="filtertext">
              {{ DrugDose }}
            </div>
            <i></i>
          </div>
          <div class="lists" [hidden]="!hideme[2]">
            <ul>
              <li *ngFor="let item of DrugDoseList" (click)="addActive_select($event, 2, item)"
                [ngClass]="{ active: item == DrugDose }">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
        <div class="lists_box">
          <div (click)="hideme[3] = !hideme[3]; $event.stopPropagation()">
            <label>Quantity</label>
            <div class="filtertext">
              {{ DrugQuant }}
            </div>
            <i></i>
          </div>
          <div class="lists" [hidden]="!hideme[3]" hidden>
            <ul>
              <li *ngFor="let item of DrugQuantityList" (click)="addActive_select($event, 3, item)"
                [ngClass]="{ active: item == DrugQuant }">{{ item }}</li>
              <li (click)="addActive_select($event, -3, QuantityManual)">Enter a Quanity</li>
            </ul>
          </div>
        </div>
        <div class="lists_box PharmacyNear">
          <div>
            <label>Pharmacies Near</label>

            <!-- <div class="filtertext">Oakland, CA 94618, USA</div> -->
            <div class="filtertext">
              <input type="text" id="getzipcodeTop" placeholder="Type zipcode" value="{{ _CurrLocation }}"
                [(ngModel)]="_UserZip" maxlength="5" (click)="ClearErrorMessage()" (blur)="ClearErrorClass($event)"
                (keyup)="zipCodeLenthInit();" (keypress)="ZipCodeValidate($event);" />
            </div>
            <!-- <i></i> -->
            <span>{{ ZipCodeMessage }}</span>
          </div>
        </div>
        <div class="autopic_location">
          <input type="checkbox" id="pick_location" (change)="GetAutoLocation($event)" />
          <label for="pick_location"><span></span>Auto pick my location</label>
        </div>
        <div class="find_button" (click)="Redirect_LoadPharmacy()">
          Find the Lowest Price
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Enter Quantity Manual Box -->
<div class="change_password" *ngIf="ManualQuantity_box">
  <!-- <div class="close_search_pharmacy_popup" (click)="removeforgot($event)"></div> -->
  <div class="changepassword_main forgot_pass">
    <h2>Enter a quantity</h2>
    <div class="input_box">
      <div>
        <input type="number" id="Quantity_Manual" name="Quantity_Manual" placeholder=" " [(ngModel)]="Quantity_Manual"
          (keypress)="DrugQuantityValidate($event)" />
        <label for="Quantity_Manual">Quantity</label>
      </div>
      <span id="Quant_Error">{{ Quantity_error }}</span>
      <div class="reset_button" (click)="SubmitQuantity()">Submit</div>
    </div>
  </div>
</div>

<!-- <app-getcard></app-getcard> -->